import { type Registry as Services, service } from '@ember/service';
import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { tracked } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';
import type { Dayjs } from 'dayjs';
import type { TotalRevenueTrendReference } from 'lumen/models';

export default class TotalRevenueTrendItem extends Model {
  [Type] = 'total-revenue/trend-item' as const;

  @hasMany('total-revenue/trend-reference', {
    async: false,
    inverse: 'totalRevenueItem',
  })
  declare referenceValues: HasMany<TotalRevenueTrendReference>;

  @attr('string') declare aggregation: 'day' | 'week' | 'month';
  @attr('hoteldate') declare date: Dayjs;
  @attr('number') declare nonRoomPremium: number;
  @attr('number') declare totalNonRoomRevenue: number;
  @attr('number') declare totalRevenue: number;
  @attr('number') declare totalRoomRevenue: number;

  @service('total-revenue')
  declare totalRevenueService: Services['total-revenue'];

  @tracked capacity?: number;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get sortedReferenceValues() {
    return this.totalRevenueService.sortReferenceValues([
      ...this.referenceValues,
    ]);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get totalNonRoomRevenueOrPAR() {
    return this.totalRevenueService.valueOrPAR(
      this.totalNonRoomRevenue,
      this.capacity,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get totalRevenueOrPAR() {
    return this.totalRevenueService.valueOrPAR(
      this.totalRevenue,
      this.capacity,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get totalRoomRevenueOrPAR() {
    return this.totalRevenueService.valueOrPAR(
      this.totalRoomRevenue,
      this.capacity,
    );
  }
}
